export const displayName = (user, useNoName = false) =>
  user.childName ||
  (user.guardianName
    ? `${user.guardianName}'s Kid`
    : useNoName
    ? 'No Name'
    : user.email);

export const displayDetails = user =>
  `${displayName(user, true)} | ${user.email ? user.email : 'No Email'} | ${
    user.phoneNumber ? user.phoneNumber : 'No Mobile'
  }`;
